import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../store";
import type { ExternalLink } from "../TreeView";
import defaultContent from "../../../content/treeView";

/**
 * Hook to get external links from market configuration for TreeView
 * Transforms the rwlos.uiGridExternalLinks config into the ExternalLink format
 */
export const useTreeViewExternalLinks = (): ExternalLink[] => {
  const { t } = useTranslation(["treeView"]);
  const configuration = useAppSelector((state) => state.boot.configuration);

  const externalLinks = useMemo(() => {
    const configLinks = configuration?.rwlos?.uiGridExternalLinks ?? [];

    return configLinks.map((link) => ({
      name: link.name,
      label: t(
        `externalLinks.${link.name}`,
        defaultContent.externalLinks[link.name as keyof typeof defaultContent.externalLinks] ?? link.name,
      ) as string,
      link: link.link,
    }));
  }, [configuration?.rwlos?.uiGridExternalLinks, t]);

  return externalLinks;
};
